module.exports = __webpack_public_path__ + "media/react/assets/magoosh-logo-purple-7526705ac1f6241ac6bb6686826618e4.png";